/** Splits at the last dot; a leading dot (".env") belongs to the name, not to an extension. */
const splitExtension = (name: string): { base: string; extension: string } => {
  const dot = name.lastIndexOf('.');
  return dot > 0 ? { base: name.slice(0, dot), extension: name.slice(dot) } : { base: name, extension: '' };
};

const nextFreeName = (name: string, taken: ReadonlySet<string>): string => {
  if (!taken.has(name)) return name;
  const { base, extension } = splitExtension(name);
  let counter = 2;
  while (taken.has(`${base} (${counter})${extension}`)) counter += 1;
  return `${base} (${counter})${extension}`;
};

/**
 * Line sources are keyed by file name + page, so two files with the same name would share provenance.
 * A file whose name is already used (by a loaded page or earlier in the batch) becomes `name (n).ext`.
 */
export const withUniqueFileNames = (files: readonly File[], usedNames: Iterable<string>): File[] => {
  const taken = new Set(usedNames);
  return files.map((file) => {
    const name = nextFreeName(file.name, taken);
    taken.add(name);
    return name === file.name ? file : new File([file], name, { type: file.type, lastModified: file.lastModified });
  });
};
